import { flexPortalApi } from 'src/api';
import { AxiosRequestConfig } from 'axios';

import { SchemeResponse, UpdatePartnerDetailsRequest } from 'src/types';

export const getSchemeListByCompanyId = (companyId: string, config: AxiosRequestConfig = {}) =>
  flexPortalApi.get<SchemeResponse[]>(`/api/v1/companies/${companyId}/schemes/all`, config);

export const getSchemeListWithDataAccessByCompanyId = (companyId: string, config: AxiosRequestConfig = {}) =>
  flexPortalApi.get<SchemeResponse[]>(`/api/v1/companies/${companyId}/schemes/data-access`, config);

export const getSchemeById = (companyId: string, schemeId: string, config: AxiosRequestConfig = {}) =>
  flexPortalApi.get<SchemeResponse>(`/api/v1/companies/${companyId}/schemes/${schemeId}`, config);

export const updatePartnerDetails = (
  companyId: string,
  schemeId: string,
  payload: UpdatePartnerDetailsRequest,
  config: AxiosRequestConfig = {},
) => flexPortalApi.patch<void>(`/api/v1/companies/${companyId}/schemes/${schemeId}`, payload, config);

export const getSchemeListByCompanyIdAndEmployerId = (
  companyId: string,
  employerId: string,
  config: AxiosRequestConfig = {},
  hasNotActivePolicy?: boolean,
) =>
  flexPortalApi.get<SchemeResponse[]>(`/api/v1/companies/${companyId}/employers/${employerId}/schemes/all`, {
    params: { hasNotActivePolicy },
    ...config,
  });
